import React from 'react';

import Row from './Base';

import Voucher from './Voucher';
import Packet from './Packet';
import Region from './Region';
import Discount from './Discount';
import Duration from './Duration';
import ExpirationDate from './ExpirationDate';
import StartDate from './StartDate';

import Options from './Options';
import Total from './Total';

const SimpleRows = [
    Voucher,
    Packet,
    Region,
    Discount,
    Duration,
    ExpirationDate,
    StartDate,
];

const getRow = (props, {className, isAvailable, getProps}) => {
    if (isAvailable(props) === false) return null;

    const rowProps = getProps(props);

    return <Row {...props} {...rowProps} className={className} key={className} />
};

const Rows = props => SimpleRows.map(row => getRow(props, row));

export {Options, Total};

export default Rows;
